/**
 * @generated SignedSource<<56b514d52cabd497b6e4a79a3ac539d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftPdpRespLayout_viewer$data = {
  readonly nftItems: ReadonlyArray<{
    readonly creatorAddress: {
      readonly publicProfile: {
        readonly profileName: string | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreatorItems_creatorAddress">;
    } | null;
    readonly exhibitions: ReadonlyArray<{
      readonly __typename: "NftCmsExhibitionPage";
    } | null> | null;
    readonly isERC1155: boolean | null;
    readonly mostRecentAuction: {
      readonly status: NftAuctionStatus | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpAbout_nftItem" | "NftPdpAdditionalContent_nftItem" | "NftPdpContractContext_nftItem" | "NftPdpCreator_nftItem" | "NftPdpExhibitionNotes_nftItem" | "NftPdpExhibitions_nftItem" | "NftPdpHistory_nftItem" | "NftPdpMedia_nftItem" | "NftPdpSharingIcons_nftItem" | "NftPdpSidebar_nftItem" | "NftPdpTabs_nftItem">;
  } | null> | null;
  readonly showExhibitionNotes: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreatorItems_viewer" | "NftPdpCreator_viewer" | "NftPdpHistory_viewer" | "NftPdpLiveDetailsRefetchWrapper_viewer" | "NftPdpSharingIcons_viewer" | "NftPdpSidebar_viewer" | "NftPdpTabs_viewer">;
  readonly " $fragmentType": "NftPdpRespLayout_viewer";
};
export type NftPdpRespLayout_viewer$key = {
  readonly " $data"?: NftPdpRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpRespLayout_viewer">;
};

import NftPdpRespLayoutRefetchQuery_graphql from './NftPdpRespLayoutRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "creatorItemCount"
    },
    {
      "kind": "RootArgument",
      "name": "fetchClientDetails"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSplitName"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isDraft"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftPdpRespLayoutRefetchQuery_graphql
    }
  },
  "name": "NftPdpRespLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpSidebar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpHistory_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpCreator_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpSharingIcons_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpCreatorItems_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isDraft",
          "variableName": "isDraft"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "nftIds.0",
              "variableName": "nftId"
            }
          ],
          "kind": "ListValue",
          "name": "nftIds"
        }
      ],
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "nftItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftAuction",
          "kind": "LinkedField",
          "name": "mostRecentAuction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionPage",
          "kind": "LinkedField",
          "name": "exhibitions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "creatorAddress",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "itemCount",
                  "variableName": "creatorItemCount"
                }
              ],
              "kind": "FragmentSpread",
              "name": "NftPdpCreatorItems_creatorAddress"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicProfile",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isERC1155",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpAbout_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpSharingIcons_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpMedia_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpSidebar_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpContractContext_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpHistory_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpTabs_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpCreator_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpAdditionalContent_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpExhibitionNotes_nftItem"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftPdpExhibitions_nftItem"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "showExhibitionNotes",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftExhibitionNotes"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftExhibitionNotes\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpLiveDetailsRefetchWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7cc50f9286f10f8f68aa4cd4c7f25cae";

export default node;
